"use strict";

exports.__esModule = true;
exports.default = omit;

function omit(obj) {
  for (var _len = arguments.length, keysToOmit = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keysToOmit[_key - 1] = arguments[_key];
  }

  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet/lib/utils/omit.js
// module id = 150
// module chunks = 0